import { NgModule } from '@angular/core';

import { InputComponent } from './input.component';

@NgModule({
  imports: [InputComponent],
  exports: [InputComponent],
})
export class InputModule {}
